'use client';

import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';

import { AttributionCapture } from '@/components/analytics/attribution-capture';
import { GaPageViews } from '@/components/analytics/ga-page-views';
import { HotjarAnalytics } from '@/components/analytics/hotjar-analytics';
import { MarketingAnalytics } from '@/components/analytics/marketing-analytics';
import { useCookieConsentHydration } from '@/hooks/use-cookie-consent-hydration';
import { useCookieConsentStore } from '@/stores/cookie-consent-store';

const gaId = process.env.NEXT_PUBLIC_GA4_ID?.trim();
const gtmId = process.env.NEXT_PUBLIC_GTM_ID?.trim();

/**
 * Loads GA4, GTM, Meta Pixel, Hotjar, and attribution capture only after cookie consent.
 * Vercel Analytics stays outside this component (cookie-less).
 */
export function ConsentGatedAnalytics() {
  const hydrated = useCookieConsentHydration();
  const status = useCookieConsentStore((s) => s.status);

  if (!hydrated || status !== 'accepted') return null;

  return (
    <>
      <AttributionCapture />
      {gaId ? <GoogleAnalytics gaId={gaId} /> : null}
      {gtmId ? <GoogleTagManager gtmId={gtmId} /> : null}
      <GaPageViews />
      <MarketingAnalytics />
      <HotjarAnalytics />
    </>
  );
}
